// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon:hover {
  transform: scale(1.2);
  cursor: pointer;
  transition: 0.2s ease-in-out;
  color: #0056b3;
}

.icon {
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/MemberItem/MemberItem.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".icon:hover {\n  transform: scale(1.2);\n  cursor: pointer;\n  transition: 0.2s ease-in-out;\n  color: #0056b3;\n}\n\n.icon {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
